
const digest = '86430035f5f06453850b221e806ab2898b98a89eb9407a14e736bedc9955bd3b';
const classes = {"wrapper":"_wrapper_1fypc_1"};
const css = `._wrapper_1fypc_1 {
  padding: 24px;
  border: 1px solid #eaedf3;
  background: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  